import { ThemeInterface } from '../interfaces/theme.interface';

export const OrtecTheme: ThemeInterface = {
  name: 'ortec',
  properties: {
  }
};